import {ChangeDetectionStrategy,Component,inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA,MatSnackBarRef} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import {ServerError,ServerErrorObject,ServerResponse} from '../../../shared/server-message';

@Component({
	selector:'app-snack-message',
	imports:[MatButtonModule],
	templateUrl:'./snack-message.html',
	styleUrl:'./snack-message.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class SnackMessageComponent{
	readonly data?:{error?:ServerError,response?:ServerResponse}|null=inject<{error?:ServerError,response?:ServerResponse}>(MAT_SNACK_BAR_DATA,{optional:true});
	private readonly snackBarRef=inject(MatSnackBarRef,{optional:true});

	protected get errorObject():ServerErrorObject|null{
		const error=this.data?.error;
		return error&&typeof error==='object'?error:null;
	}

	dismiss():void{
		this.snackBarRef?.dismiss();
	}
}
